import semver from 'semver';

// Entries may be exact versions (for example, "1.2.3") or ranges (for example, ">=1.2.0 <2.0.0").
// Add one only when every stored canvas matching it must be blocked.
const DENIED_CANVAS_SDK_VERSION_RANGES: ReadonlyArray<string> = [];

export function isCanvasSdkVersionDenied(
  sdkVersion: string,
  deniedVersionRanges: ReadonlyArray<string> = DENIED_CANVAS_SDK_VERSION_RANGES
): boolean {
  return deniedVersionRanges.some((versionRange) => semver.satisfies(sdkVersion, versionRange));
}
